<template>
  <b-modal id="modal-filter-ct" size="md" modal-class="mc-modal-right" title="Filter">
    <div class="mc-control-tower__modal">
      <div class="mc-modal__filter">
        <div class="mc-modal__filter-item">
          <label class="mt-3">{{ $t('global.condition') }}</label>
          <multiselect
            class="mc-control-tower__condition-multiselect-status"
            v-model="conditionModel"
            :options="conditionOption"
            :placeholder="$t('global.condition')"
          >
            <template slot="singleLabel" slot-scope="props">
              <div>
                <span :class="props.option.color"></span><span>{{ props.option.label }}</span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div>
                <span>{{ props.option.color }}</span
                ><span>{{ props.option.label }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="mc-modal__filter-item">
          <label class="mt-3">{{ $t('global.object.fleetGroup') }}</label>
          <multiselect
            v-model="fleetGroupModel"
            :options="fleetGroupOptions"
            label="name"
            track-by="id"
            :placeholder="$t('global.form.select') + ' ' + $t('global.object.fleetGroup')"
          ></multiselect>
        </div>
        <!-- <div class="mc-modal__filter-item">
          <label class="mt-3">Tampil Berdasarkan</label>
          <multiselect
            v-model="viewOrderModel"
            :options="viewOrderOption"
            label="label"
            placeholder="Tampil Berdasarkan"
          ></multiselect>
        </div> -->
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-model="licensePlateModel"
            type="value-help-v2"
            name="vehicleId"
            :label="$t('global.object.licensePlate')"
            trackBy="id"
            :placeholder="$t('global.form.select') + ' ' + $t('global.object.licensePlate')"
            :displayedBy="'licensePlate'"
            :fullObject="fullObject"
            :listGetter="resourcefulQuery.vehicleOptions"
            @update:fullObject="fullObject = $event"
            :multiple="true"
            :tableFields="tableFields"
            :modalTitle="$t('global.form.select') + ' ' + $t('global.object.licensePlate')"
          >
          </FormulateInput>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="mc-modal__filter-footer">
        <div class="d-flex flex-row-reverse">
          <div>
            <b-button variant="outline-primary" class="me-2" @click="cancelModal()">{{
              $t('global.action.cancel')
            }}</b-button>
            <b-button variant="primary" @click="onSubmit">{{ $t('global.action.apply') }}</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect,
  },
  props: {
    vehicles: {
      required: true,
    },
  },
  data() {
    return {
      conditionModel: null,
      fleetGroupModel: null,
      viewOrderModel: null,
      licensePlateModel: [],
      rendered: true,
      fullObject: {},
    }
  },

  computed: {
    resourcefulQuery() {
      return {
        vehicleOptions: (opt) => this.calculatedData(opt),
      }
    },
    fleetGroupOptions() {
      const options = [
        { id: 0, name: this.$t('global.filter.all') },
        ...this.$store.state.access.vGroups,
      ]
      return options
    },
    tableFields() {
      return [
        {
          label: this.$t('global.object.licensePlate'),
          key: 'licensePlate',
          isSortable: false,
        },
        {
          label: this.$t('global.field.vehicleType'),
          key: 'vehicleType',
          formatter(val) {
            const label = [val.category, val.model, val.type]
            return label.filter((x) => x !== null).join('/')
          },
          isSortable: false,
        },
      ]
    },
    conditionOption() {
      return [
        { key: 'all', label: this.$t('global.filter.all'), color: 'all' },
        { key: 'U', label: this.$t('tower.problems'), color: 'red' },
        { key: 'R', label: this.$t('tower.checked'), color: 'yellow' },
        { key: 'N', label: 'Normal', color: 'green' },
        { key: 'O', label: 'Offline', color: 'gray' },
      ]
    },
    viewOrderOption() {
      return [
        { key: 'driver', label: this.$t('global.driver') },
        { key: 'licensePlate', label: this.$t('global.object.licensePlate') },
        { key: 'hullNo', label: this.$t('global.object.hullNo') },
      ]
    },
  },

  methods: {
    calculatedData(opt) {
      let vehicles = [...this.vehicles]
      if (opt.search) {
        vehicles = vehicles.filter((x) =>
          x.licensePlate.toLowerCase().match(opt.search.toLowerCase())
        )
      }
      const result = {
        metadata: {
          total_count: vehicles.length,
          page: Math.ceil(vehicles.length / opt.limit),
        },
        data: {
          paginated_result: vehicles,
          ids: vehicles.map((x) => x.id),
        },
      }

      return result
    },
    licensePlateModal() {
      this.$bvModal.show('modal-license-fleet')
    },

    cancelModal() {
      this.$bvModal.hide('modal-filter-ct')
    },

    onSubmit() {
      const form = {
        condition: this.conditionModel,
        vGroup: this.fleetGroupModel,
        viewOrder: this.viewOrderModel,
        licensePlate: this.licensePlateModel.map((x) => Number(x)),
      }

      this.$emit('onFiltered', form)

      this.cancelModal()
    },
  },
}
</script>
